/* UI de Rosvelet: header, menú, carrito lateral, botones de agregar (vuelo al carrito), efectos de scroll y fichas.
   El HTML lo genera Liquid; el carrito vive en cart.js (AJAX Cart API). */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var R = window.Rosvelet, S = R.strings;
  var RVM = window.RVM, RVCart = window.RVCart;
  var page = document.body.dataset.page;
  var reduce = RVM.reduced;
  var root = document.documentElement;

  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function countTxt(n) { return n === 1 ? S.countOne : S.countOther.replace('99999', n); }
  function announce(msg) { $$('[data-cart-live]').forEach(function (b) { b.textContent = msg; }); }

  /* ---------- Trampa de foco e inert del fondo ---------- */
  function trap(e, box) {
    if (e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', box).filter(function (x) { return x.getClientRects().length; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === box)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  /* Con un diálogo abierto, el resto de la página queda inerte (sin foco ni lector de pantalla). */
  function setInert(on) {
    $$('main, .site-header, .site-footer, .wa, .announce, .skip').forEach(function (el) { el.inert = on; });
  }
  function lockScroll(on) {
    if (on) root.style.setProperty('--sbw', Math.max(0, window.innerWidth - root.clientWidth) + 'px');
    document.body.classList.toggle('lock', on);
    if (!on) root.style.removeProperty('--sbw');
  }

  /* ---------- Carrito lateral ---------- */
  var drawer = $('#cart-drawer'), overlay = $('.overlay'), lastFocus = null, lastCount = parseInt(($('[data-cart-count]') || {}).textContent, 10) || 0;

  function openDrawer() {
    if (!drawer || page === 'cart') return;
    lastFocus = document.activeElement;
    lockScroll(true); setInert(true);
    drawer.classList.add('open'); overlay.classList.add('open');
    $('[data-close-cart].icon-btn', drawer).focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('open')) return;
    drawer.classList.remove('open'); overlay.classList.remove('open'); lockScroll(false); setInert(false);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  function updateBadge(n) {
    var up = n > lastCount;
    $$('[data-cart-count]').forEach(function (b) {
      b.hidden = !n;
      if (n) RVM.roll(b, n, up ? 'up' : 'down');
      if (up) RVM.bump(b, 1.35);
    });
    if (up) RVM.bump($('.cart-btn svg'), 1.18);
    lastCount = n;
  }
  document.addEventListener('cart:change', function (e) { updateBadge(e.detail.count); });

  /* ---------- Toast (errores de red / stock) ---------- */
  function toast(msg) {
    var t = $('.toast') || document.body.appendChild(Object.assign(document.createElement('div'), { className: 'toast', role: 'status' }));
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('show'); }, 4500);
  }
  document.addEventListener('cart:error', function (e) { toast(e.detail.message); announce(e.detail.message); });

  /* ---------- Agregar: giro -> vuelo al carrito -> "Agregado" -> cajón ---------- */
  function flySource(btn) {
    var card = btn.closest('.card, .bundle, .pdp-bundle'), g = $('.gallery__slide img'), vid = btn.closest('.reel, .gallery__slide--vid');
    if (vid) return $('.vid', vid);
    if (card) return $('img', card);
    var r = g && g.getBoundingClientRect();
    return r && r.bottom > 0 && r.top < window.innerHeight ? g : null; // barra fija: sale del botón
  }
  function addFeedback(btn, items, name) {
    if (btn.classList.contains('is-busy') || !items.length) return;
    var orig = btn.innerHTML, fast = reduce();
    btn.style.minWidth = btn.offsetWidth + 'px';
    btn.classList.add('is-busy');
    if (!fast) btn.innerHTML = '<span class="spin" aria-hidden="true"></span> ' + S.adding;
    function reset() { btn.innerHTML = orig; btn.classList.remove('is-busy', 'is-done'); btn.style.minWidth = ''; }
    var req = RVCart.requestAdd(items).then(function (html) { return { html: html }; }, function (err) { return { err: err }; });
    var fly = new Promise(function (done) { RVM.fly(flySource(btn) || btn.querySelector('.spin') || btn, done); });
    Promise.all([req, fly]).then(function (r) {
      if (r[0].err) { reset(); RVCart.showError(r[0].err.message); return; }
      RVCart.apply(r[0].html).then(function (n) {
        announce(S.addedLive.replace('__NAME__', name || '').replace('__COUNT__', countTxt(n)));
        btn.innerHTML = CHECK + ' ' + S.added; btn.classList.add('is-done');
        setTimeout(openDrawer, fast ? 0 : 160);
        setTimeout(reset, 1400);
      });
    });
  }

  function itemsFromForm(form) {
    var id = parseInt(($('[name="id"]', form) || {}).value, 10);
    var q = $('[name="quantity"]', form), qty = q ? Math.max(1, Math.min(99, parseInt(q.value, 10) || 1)) : 1;
    return id ? [{ id: id, quantity: qty }] : [];
  }
  function itemsFromBundle(str) {
    return String(str || '').split(',').map(function (p) {
      var a = p.split(':'); return { id: parseInt(a[0], 10), quantity: parseInt(a[1], 10) || 1 };
    }).filter(function (i) { return i.id; });
  }

  /* ---------- Clics delegados ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-add],[data-add-form],[data-bundle],[data-act],[data-open-cart],[data-close-cart],[data-menu-open],[data-menu-close]');
    if (!t) return;
    if (t.matches('[data-bundle]')) addFeedback(t, itemsFromBundle(t.dataset.bundle), t.dataset.name);
    else if (t.matches('[data-add-form]')) addFeedback(t, itemsFromForm($(t.dataset.addForm)), t.dataset.name);
    else if (t.matches('[data-add]')) addFeedback(t, [{ id: parseInt(t.dataset.variantId, 10), quantity: 1 }], t.dataset.name);
    else if (t.matches('[data-act]')) lineAction(t);
    else if (t.matches('[data-open-cart]')) { if (drawer && page !== 'cart') { e.preventDefault(); openDrawer(); } }
    else if (t.matches('[data-close-cart]')) closeDrawer();
    else if (t.matches('[data-menu-open]')) toggleMenu(true);
    else toggleMenu(false);
  });

  /* "Agregar al carrito" de la ficha = envío del formulario del producto */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-product-form]')) return;
    e.preventDefault();
    var btn = $('[data-add-submit]', form);
    if (btn && !btn.disabled) addFeedback(btn, itemsFromForm(form), btn.closest('.pdp') ? ($('.pdp h1') || {}).textContent : '');
  });

  function lineAction(btn) {
    var key = btn.dataset.key, act = btn.dataset.act, wrap = btn.closest('.line-wrap');
    var q = parseInt(wrap.dataset.qty, 10);
    if (act === 'dec' && q === 1) act = 'rm';
    if (act === 'rm') return removeLine(wrap, key);
    RVCart.change(key, act === 'inc' ? q + 1 : q - 1).catch(function (err) { RVCart.showError(err.message); });
  }
  /* Quitar: la línea se desliza, el alto colapsa (grid 1fr -> 0fr) y luego Shopify confirma el nuevo carrito. */
  function removeLine(wrap, key) {
    var host = wrap.closest('[data-lines]');
    function done() {
      RVCart.change(key, 0).then(function () {
        ($('.line__name', host) || $('.empty a', host) || host).focus({ preventScroll: true });
      }).catch(function (err) { wrap.classList.remove('out'); RVCart.showError(err.message); });
    }
    if (reduce()) { done(); return; }
    if (wrap.classList.contains('out')) return;
    wrap.classList.add('out');
    var fin = false;
    function once() { if (fin) return; fin = true; done(); }
    wrap.addEventListener('transitionend', function (ev) { if (ev.target === wrap) once(); });
    setTimeout(once, 450);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); toggleMenu(false); }
    if (drawer && drawer.classList.contains('open')) trap(e, drawer);
    var menu = $('#mobile-menu');
    if (menu && menu.classList.contains('open')) trap(e, menu);
  });

  /* ---------- Menú móvil ---------- */
  function toggleMenu(open) {
    var m = $('#mobile-menu'), b = $('[data-menu-open]');
    if (!m || m.classList.contains('open') === open) return;
    m.classList.toggle('open', open);
    b.setAttribute('aria-expanded', open);
    lockScroll(open); setInert(open);
    if (open) $('[data-menu-close]', m).focus({ preventScroll: true }); else b.focus({ preventScroll: true });
  }

  /* ---------- Inicio: orden del catálogo con FLIP ---------- */
  function initCatalog() {
    var grid = $('#featured'), sel = $('#sort');
    if (!grid || grid.dataset.init) return;
    grid.dataset.init = '1';
    var cards = $$('.card', grid);
    $$('[data-count-products]').forEach(function (c) { c.textContent = countTxt(cards.length); });
    if (!sel) return;
    function sorted() {
      var list = cards.slice();
      if (sel.value === 'asc') list.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      else if (sel.value === 'desc') list.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      else list.sort(function (a, b) { return a.dataset.index - b.dataset.index; });
      return list;
    }
    sel.addEventListener('change', function () {
      var first = cards.map(function (el) { return el.getBoundingClientRect(); });
      sorted().forEach(function (c) { grid.appendChild(c); });
      grid.scrollLeft = 0;
      if (!reduce()) {
        var last = cards.map(function (el) { return el.getBoundingClientRect(); });
        cards.forEach(function (el, i) {
          var dx = first[i].left - last[i].left, dy = first[i].top - last[i].top;
          if (!dx && !dy) return;
          el.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: 480, easing: 'cubic-bezier(.2,.7,.2,1)' });
        });
      }
      var live = $('#sort-live');
      if (live) live.textContent = S.sortedLive.replace('__SORT__', sel.options[sel.selectedIndex].text.toLowerCase()).replace('__COUNT__', countTxt(cards.length));
    });
  }

  /* Colección: el selector de orden recarga con ?sort_by= */
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-sort-nav]')) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* ---------- Ficha de producto ---------- */
  function initProduct() {
    var main = $('.pdp');
    if (!main || main.dataset.init) return;
    main.dataset.init = '1';
    var qty = $('#pdp-qty'), form = $('[data-product-form]');
    main.addEventListener('click', function (e) {
      var s = e.target.closest('[data-step]');
      if (s) {
        var before = parseInt(qty.value, 10) || 1;
        qty.value = Math.min(99, Math.max(1, before + parseInt(s.dataset.step, 10)));
        if (+qty.value !== before) RVM.rollIn(qty, +s.dataset.step > 0 ? 'up' : 'down');
      }
      var th = e.target.closest('[data-thumb]');
      if (th) {
        var m = $('.gallery__main'), to = m.clientWidth * th.dataset.thumb;
        if (reduce() || !m.animate || Math.abs(m.scrollLeft - to) < 2) m.scrollTo({ left: to, behavior: 'auto' });
        else m.animate([{ opacity: 1 }, { opacity: .12 }], { duration: 130, fill: 'forwards' }).onfinish = function () {
          m.scrollTo({ left: to, behavior: 'auto' });
          m.animate([{ opacity: .12 }, { opacity: 1 }], { duration: 220 }).onfinish = function () { m.getAnimations().forEach(function (a) { a.cancel(); }); };
        };
      }
    });
    qty.addEventListener('change', function () { qty.value = Math.min(99, Math.max(1, parseInt(qty.value, 10) || 1)); });

    var gal = $('.gallery__main');
    gal.addEventListener('scroll', function () {
      var i = Math.round(gal.scrollLeft / gal.clientWidth);
      $$('.thumb').forEach(function (b, k) { b.setAttribute('aria-current', k === i); });
    }, { passive: true });

    /* Variantes: el precio y la disponibilidad salen de los data-* que escribe Liquid */
    var sel = $('[data-variant-select]');
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex], box = $('.pdp [data-price-box]');
      $('[data-price]', box).textContent = o.dataset.price;
      var cmp = $('[data-compare]', box), off = $('[data-off]', box);
      if (cmp) cmp.textContent = o.dataset.compare || '';
      if (cmp && !o.dataset.compare) { cmp.hidden = true; if (off) off.hidden = true; }
      else if (cmp) { cmp.hidden = false; if (off) off.hidden = false; }
    });

    var bar = $('#sticky');
    if (!bar || !form) return;
    // Revisión por scroll en vez de IntersectionObserver: un fling rápido puede saltar el botón sin "intersectar".
    var addBtn = $('#pdp-add'), want = false;
    RVM.onFrame({
      read: function () { want = addBtn.getBoundingClientRect().bottom < 0; },
      write: function () {
        if (bar.classList.contains('show') === want) return;
        bar.classList.toggle('show', want);
        document.body.classList.toggle('has-sticky', want);
        bar.setAttribute('aria-hidden', !want);
        $('button', bar).tabIndex = want ? 0 : -1;
      }
    });
  }

  /* ---------- Nav activo (inicio) ---------- */
  function initNav() {
    if (page !== 'index') return;
    var links = $$('.nav a[data-nav], #mobile-menu nav a[data-nav]'), shown = null;
    function mark(k) {
      if (k === shown) return;
      shown = k;
      links.forEach(function (a) {
        if (a.dataset.nav === k) a.setAttribute('aria-current', k === 'index' ? 'page' : 'location'); else a.removeAttribute('aria-current');
      });
    }
    mark('index');
    var secs = ['productos', 'ayuda'].map(function (id) { return document.getElementById(id); }), hdr = $('#site-header'), cur = 'index';
    /* Activa = última sección cuyo borde superior ya pasó bajo el header; Inicio si aún no llega a Productos. */
    RVM.onFrame({
      read: function () {
        var line = (hdr ? hdr.offsetHeight : 76) + 24;
        cur = 'index';
        secs.forEach(function (el) { if (el && el.getBoundingClientRect().top <= line) cur = el.id; });
      },
      write: function () { mark(cur); }
    });
  }

  /* Ancla en carga: content-visibility/reveal cambian alturas, así que se recoloca al asentarse el layout. */
  function cleanHash() { if (window.location.hash) history.replaceState(null, '', window.location.pathname + window.location.search); }
  function settleHash() {
    if (!window.location.hash || page !== 'index') return;
    var t = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    if (!t) return;
    var n = 0;
    (function fix() {
      t.scrollIntoView({ behavior: 'instant', block: 'start' });
      if (++n < 4) setTimeout(fix, 250); else cleanHash();
    })();
  }
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a || a.classList.contains('skip') || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var u = new URL(a.href, window.location.href), t = u.hash && document.getElementById(decodeURIComponent(u.hash.slice(1)));
      if (!t || u.pathname !== window.location.pathname || u.search !== window.location.search) return;
      e.preventDefault();
      setTimeout(function () {
        t.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' }); cleanHash();
        // content-visibility cambia alturas durante el scroll suave: se reasienta al terminar
        [900, 1700].forEach(function (ms) { setTimeout(function () { if (Math.abs(t.getBoundingClientRect().top - 88) > 3) t.scrollIntoView({ behavior: 'instant', block: 'start' }); }, ms); });
      }, a.closest('#mobile-menu') ? 80 : 0);
    }, true);
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'reload' && !window.location.hash) { // refresh = inicio; atrás/adelante conservan su posición
      history.scrollRestoration = 'manual'; window.scrollTo(0, 0);
      window.addEventListener('load', function () { setTimeout(function () { history.scrollRestoration = 'auto'; }, 300); });
    }
  }

  /* Saltar al contenido: mueve el foco a <main> (el ancla sola no lo hace en todos los navegadores). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.skip'), m = $('#main');
    if (!a || !m) return;
    e.preventDefault(); m.focus({ preventScroll: true }); m.scrollIntoView({ behavior: 'auto', block: 'start' });
  });

  /* Editor de temas: las secciones se vuelven a pintar sin recargar la página */
  document.addEventListener('shopify:section:load', function (e) {
    RVM.refresh(e.target); RVM.initAcc(e.target);
    if (window.RVVideo) window.RVVideo.init(e.target);
    initCatalog(); initProduct();
  });

  /* ---------- Init ---------- */
  initNav();
  if (page === 'index') initAnchors();
  initCatalog();
  initProduct();
  if (window.RVVideo) window.RVVideo.init(document);
  RVM.refresh();
  RVM.initAcc(document);
  if (document.readyState === 'complete') settleHash(); else window.addEventListener('load', settleHash);
})();

// Cierra el menú de cuenta al hacer clic fuera o con Escape.
document.addEventListener('click', (e) => {
  document.querySelectorAll('.acct-menu[open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') document.querySelectorAll('.acct-menu[open]').forEach((d) => { d.open = false; });
});
